module.exports = __webpack_public_path__ + "img/wthd-logo2.e6a3de1e.png";